import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useMusic } from './hooks/useMusic';
import { WS_URL } from './config/apiConfig';
import { getWebSocketAuthMessage } from './config/apiConfig';
import { needsTokenRefresh, refreshToken } from './auth';
import DevAutobattlerUI from './devAutobattler/DevAutobattlerUI';
import { useContainerScale } from './hooks/useViewportScale';
import './Autobattler.css';

function DevAutobattler({ user, onLogout }) {
  const { t } = useTranslation();
  
  // Viewport scaling for responsive design
  const { 
    scale: viewportScale, 
    offsetX: viewportOffsetX, 
    offsetY: viewportOffsetY,
    baseWidth: containerBaseWidth,
    baseHeight: containerBaseHeight,
    isMobile: isContainerMobile
  } = useContainerScale();
  
  useMusic('/music/Epic_1.mp3');
  
  const [ws, setWs] = useState(null);
  const [initialGameState, setInitialGameState] = useState(null);
  const [initialGameId, setInitialGameId] = useState(null);
  const [initialTurn, setInitialTurn] = useState(1);
  
  const userId = typeof user === 'string' ? user : (user?.id || user?.username);
  const token = localStorage.getItem('token');

  // Setup WebSocket connection
  useEffect(() => {
    if (ws) return; // Already connected

    const socket = new window.WebSocket(WS_URL);
    setWs(socket);

    socket.onopen = () => {
      const currentLanguage = localStorage.getItem('i18nextLng') || 'en-us';
      const normalizedLanguage = currentLanguage.toLowerCase().replace('_', '-');
      const token = localStorage.getItem('token');
      socket.send(JSON.stringify(getWebSocketAuthMessage(token, normalizedLanguage)));
    };

    socket.onmessage = (event) => {
      try {
        const data = JSON.parse(event.data);

        if (data.type === 'authenticated') {
          // WebSocket authenticated, ready to use
          console.log('Dev Autobattler WebSocket authenticated');
        } else if (data.type === 'dev-autobattler-started') {
          // Game started
          setInitialGameState(data.gameState);
          setInitialGameId(data.gameId);
          setInitialTurn(data.currentTurn || 1);
        } else if (data.type === 'dev-autobattler-turn-complete' || data.type === 'dev-autobattler-game-ended') {
          // Update game state
          setInitialGameState(data.gameState);
        }
      } catch (error) {
        console.error('Error parsing WebSocket message:', error);
      }
    };

    socket.onerror = (error) => {
      console.error('Dev Autobattler WebSocket error:', error);
    };

    socket.onclose = () => {
      setWs(null);
    };

    return () => {
      if (socket) {
        socket.close();
      }
    };
  }, []);

  return (
    <div className={`autobattler-container${isContainerMobile ? ' mobile' : ''}`} style={{
      width: `${containerBaseWidth}px`,
      height: `${containerBaseHeight}px`,
      transform: `translate(${viewportOffsetX}px, ${viewportOffsetY}px) scale(${viewportScale})`,
      transformOrigin: 'top left'
    }}>
      <DevAutobattlerUI
        ws={ws}
        userId={userId}
        initialGameState={initialGameState}
        initialGameId={initialGameId}
        initialTurn={initialTurn}
        token={token}
        onLogout={onLogout}
      />
    </div>
  );
}

export default DevAutobattler;
